// ── reports-write: honest write-error → message + tone (Wave 7) ─────────────
// Mirrors sessions-helpers' describeSessionWriteError. Maps a report write error
// (mark-reviewed / approve) to an honest, non-leaking message via the single CO_*
// → posture map, so the review section speaks the exact same vocabulary as the
// list/detail reads. A denied review reads as its honest message (never a leak of
// WHY beyond "your role can't"); a closed lane states nothing changed.

import { ApiClientError } from "../../services/api-client";
import {
  honestGateFromError,
  postureForCoachingError,
  referenceFromError
} from "../../services/coaching-error-posture";

export interface WriteErrorView {
  tone: "error" | "warning";
  message: string;
}

export function describeReportWriteError(error: unknown): WriteErrorView | null {
  if (error == null) return null;
  if (!(error instanceof ApiClientError)) {
    return { tone: "error", message: "Couldn't complete the report action. Please try again." };
  }
  const posture = postureForCoachingError(error);
  const reference = referenceFromError(error);
  const ref = reference ? ` (reference: ${reference})` : "";

  if (posture === "permission-denied") {
    return { tone: "error", message: "Your role can't make this change to this report." };
  }
  if (posture === "gate-closed") {
    const gate = honestGateFromError(error);
    return { tone: "warning", message: `${gate?.reason ?? "This action is closed right now."} No change was made.` };
  }
  if (posture === "unavailable") {
    return { tone: "error", message: "Coaching is temporarily unavailable. Try again in a moment." };
  }
  // validation / not-found / generic — show the server message + reference.
  return { tone: "error", message: `${error.message}${ref}` };
}
